// extracted by mini-css-extract-plugin
export default {"cardSectionContainer":"CardSection__cardSectionContainer___FXT96","cardSectionTitle":"CardSection__cardSectionTitle___oU8WB"};